import { Button, styled } from '@mui/material';

export const sxStyle = {
  root: {
    width: '100%',
    maxWidth: {
      xs: '100%',
      sm: '600px',
      md: '800px',
      lg: '900px',
    },
    margin: 0,
  },
  closeIconContainer: {
    display: 'flex',
    justifyContent: 'end',
  },
  warningIcon: {
    color: '#F8D000',
    width: { xs: '80px', sm: '120px' },
    height: { xs: '80px', sm: '120px' },
  },
  firstText: {
    color: '#000000',
    marginTop: '-10px',
    fontSize: { xs: '20px', sm: '24px' },
    fontWeight: 700,
    textAlign: 'center',
  },
  secondaryText: {
    textAlign: 'center',
    fontSize: { xs: '14px', sm: '16px' }, // más chico
    mt: 1,
    marginBottom: { xs: '15px', sm: '25px' },
    lineHeight: 1.4,
  },
  buttonContainer: {
    alignItems: { xs: 'center', sm: 'initial' },
  },
};

export const StyledButton = styled(Button)(({ theme }) => ({
  paddingLeft: 16,
  paddingRight: 16,
  textTransform: 'none',
  fontFamily: 'Open Sans, sans-serif',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  fontSize: '18px',
  bgcolor: theme.primary,
  color: theme.text1,
  height: '45px',
  fontWeight: 600,
  borderRadius: 1,
  width: '165px',
}));
